import {
    ColorThematicStyler,
    DefaultColorThematicStyler,
    ScheduleColorThematicStyler,
    TerritoryColorThematicStyler
} from "./ColorThematicStyler";
import {SizeThematicStyler} from "./SizeThematicStyler";
import {ILayerView} from "@esWebAPI/es/model/Layer";
import TerritoryModel from "@esWebAPI/es/map/TerritoryModel";
import {SymbolThematicStyler} from "@esWebAPI/es/map/styler/SymbolThematicStyler";
import {IRoutingModule} from "@esWebAPI/es/map/module/ScheduleModule";


export class ThematicStylerFactory {

    private readonly _territoryModel: TerritoryModel|undefined;
    private readonly _routingModule: IRoutingModule|undefined;

    constructor(territoryModel?: TerritoryModel, routingModule?: IRoutingModule) {
        this._territoryModel = territoryModel;
        this._routingModule = routingModule;
    }

    public getColorStyler(layerView: ILayerView): ColorThematicStyler {
        if (this._territoryModel?.hasTerritory()) {

            if (layerView.$type === "MapScopeCustomPointLayerView" ||
                layerView.$type === "MapScopeTerritoryCentersLayerView" ||
                (layerView.geomType === "POLYGON" &&
                    (!this._territoryModel.isBaseOrRelatedLayer(layerView.id) && !this._territoryModel.isOutlinesLayer(layerView.id)))) {
                // MapScope and normal polygon layers on territories should use the default styler
                return new DefaultColorThematicStyler();
            }

            return new TerritoryColorThematicStyler(this._territoryModel);
        }
        if (this._routingModule &&
            (layerView.$type === "ScheduleLayerView" ||  // Schedule Line Layer
            layerView.styleSettings.$type === "SchedulePointStyleSettings" || // Schedule Point/Cluster layer
            (layerView.$type === "DefaultLayerView" && layerView.geomType === "POINT") ||  // DayTrip Point/Cluster layer
            (layerView.$type === "MapScopeCustomPointLayerView" && layerView.geomType === "POINT"))) { // DayTrip Address points layer
            return new ScheduleColorThematicStyler(this._routingModule);
        }
        return new DefaultColorThematicStyler();
    }

    public getSymbolStyler() {
        return new SymbolThematicStyler();
    }

    public getSizeStyler() {
        return new SizeThematicStyler();
    }
}